import styled from "styled-components";

export const Loading = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 100vh;
  justify-content: center;
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999 !important;
  /*transparent*/
  /* align-items: center;
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  position: absolute;
  inset: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.6); */
`;
